import { render, staticRenderFns } from "./TierResellerUpdate.vue?vue&type=template&id=4a48e296&scoped=true&"
import script from "./TierResellerUpdate.vue?vue&type=script&lang=js&"
export * from "./TierResellerUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a48e296",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VIcon,VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a48e296')) {
      api.createRecord('4a48e296', component.options)
    } else {
      api.reload('4a48e296', component.options)
    }
    module.hot.accept("./TierResellerUpdate.vue?vue&type=template&id=4a48e296&scoped=true&", function () {
      api.rerender('4a48e296', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Agent/components/Tier/TierResellerUpdate.vue"
export default component.exports